import { Navigate, RouteObject } from "react-router-dom";
import CTeView from "src/pages/Privada/Fiscal/CTe/CTe.View";
import CTeCadastroView from "src/pages/Privada/Fiscal/CTe/Cadastro/CTe.Cadastro";
import CTeCadastroCaracteristicasView from "./Cadastro/CTe.Cadastro.Caracteristicas.View";
import CTeCadastroPercursoView from "./Cadastro/CTe.Cadastro.Percurso.View";
import CTeCadastroTributacaoView from "./Cadastro/CTe.Cadastro.Tributacao.View";
import CTeCadastroRemetenteView from "./Cadastro/CTe.Cadastro.Remetente.View";
import CTeCadastroDestinatarioView from "./Cadastro/CTe.Cadastro.Destinatario.View";
import CTeCadastroCargaView from "./Cadastro/CTe.Cadastro.Carga.View";
import CTeCadastroValoresView from "./Cadastro/CTe.Cadastro.Valores.View";
import CTeCadastroDocumentosView from "./Cadastro/CTe.Cadastro.Documentos.View";
import CTeCadastroFinalizacaoView from "./Cadastro/CTe.Cadastro.Finalizacao.View";
import CTeImportarXmlView from "./ImportarXml/CTe.ImportarXml.View";

export const CTeRoutes: RouteObject[] = [
  {
    path: "fiscal/cte",
    element: <CTeView />,
    children: [],
  },
  {
    path: "fiscal/cte/importar-xml",
    element: <CTeImportarXmlView />,
  },
  {
    path: "fiscal/cte/cadastro",
    element: <CTeCadastroView />,
    children: [
      { index: true, element: <Navigate to="caracteristicas" replace /> },
      { path: "caracteristicas", element: <CTeCadastroCaracteristicasView /> },
      { path: "percurso", element: <CTeCadastroPercursoView /> },
      { path: "tributacao", element: <CTeCadastroTributacaoView /> },
      { path: "remetente", element: <CTeCadastroRemetenteView /> },
      { path: "destinatario", element: <CTeCadastroDestinatarioView /> },
      { path: "carga", element: <CTeCadastroCargaView /> },
      { path: "valores", element: <CTeCadastroValoresView /> },
      { path: "documentos", element: <CTeCadastroDocumentosView /> },
      { path: "finalizacao", element: <CTeCadastroFinalizacaoView /> },
    ],
  },
];
